<div class="w-full" [dir]="isRtl ? 'rtl' : 'ltr'">
   <div class="main-range relative w-full py-6">
     <!-- Range Track -->
     <div class="absolute left-0 right-0 top-1/2 h-2 -translate-y-1/2 bg-slate-200 rounded-full z-10"></div>
 
     <!-- Filled Range -->
     <div
       class="absolute top-1/2 h-2 bg-slate-700 rounded-full z-20"
       [style.left.%]="isRtl ? 100 - getPercentage(inputValue) : 0"
       [style.right.%]="isRtl ? 0 : 100 - getPercentage(inputValue)"
       [style.transform]="isRtl ? 'translateY(-50%) scaleX(-1)' : 'translateY(-50%)'"
     ></div>
 
     <!-- Thumb -->
     <div class="thumb-hundlar" [style.left.%]="isRtl ? 100 - getPercentage(inputValue) : getPercentage(inputValue)">
       <div class="thumb">
         {{ inputValue }}
       </div>
     </div>
 
     <!-- Input Range (Transparent) -->
     <input
       type="range"
       [min]="min"
       [max]="max"
       [attr.step]="100"
       [(ngModel)]="inputValue"
       (change)="updateValue($event)"
       class="absolute left-0 right-0 top-0 h-full w-full opacity-0 z-40 cursor-pointer"
     />
   </div>
 
   <!-- Labels -->
   <div class="w-[103%] flex justify-between mt-3">
      <span class="rang-step">50</span>
      <span class="rang-step"></span>
      <span class="rang-step">200</span>
      <span class="rang-step"></span>
      <span class="rang-step">400</span>
      <span class="rang-step"></span>
      <span class="rang-step">600</span>
      <span class="rang-step"></span>
      <span class="rang-step">800</span>
      <span class="rang-step"></span>
      <span class="rang-step">1000</span>
    </div>
 </div>
 